import { TileLayerOptions } from "leaflet";
import { Subsystem, UserLocation } from "@traceair/browser-tracking-lib";

export interface IConfig {
  endpoints: {
    gcpApp: string;
    qcApp: string;
    gcpRequestApp: string;
    gcpRegistryApp: string;
    loginPage: string;
    loginService: string;
    backofficeWebApp: string;
    backofficeApi: string;
    backofficeApiV2: string;
    csuApi: string;
    backofficeStorage: string;
  };
  pointZoom: number;
  // because existing points can be found in radius of 50 feet
  // we need a higher zoom than for ordinary gcps
  existingPointZoom: number;
  osmLayerOptions: TileLayerOptions;
  orthophotoLayerOptions: TileLayerOptions;
  satelliteOrthophotoLayerOptions: TileLayerOptions;
  elevationMapLayerOptions: TileLayerOptions;
  detailedDemDiffLayerOptions: TileLayerOptions;
  bufferZonesLayerOptions: {
    minZoomLevelToShowBufferZones: number;
  };

  gcpRequestAsanaTaskUrlPattern: string;

  favicon: string;
  tileCredentialsUpdateOvertakeMs: number;
  tokenUpdateOvertakeFactor: number;
  entryPoints: {
    backofficeDashboard: string;
    gcpRequestEmail: string;
  };
  language: string;
  proposedFlightMarkerAltitude: number;
  esriApiKey: string;
  installedFlightMarkersUpdateInterval: number;
  tracking: {
    subsystem: Subsystem;
    enabled: boolean;
    environment: string;
    location: UserLocation;
    backendUrl: string;
  };
  sentry: {
    enabled: boolean;
    environment: string;
    dsn: string;
  };
  intercom: {
    enabled: boolean;
    appId: string;
    hideLauncher: boolean;
    userIdentityEndpointUrl: string;
  };
}

// This variable is defined in a separate script, that is generated
// by webpack and included in index.ejs
declare let config: IConfig;

export default config;

export function assertConfig(conf: IConfig) {
  if (!conf.installedFlightMarkersUpdateInterval) {
    throw new Error("installedFlightMarkersUpdateInterval is not set");
  }
  // TODO Check all config fields
}
